<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Name<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="job" class="font-light" >Job title<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.job" placeholder="" name="job" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="type" class="font-light" >Type of Certificate(s)<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.type" placeholder="" name="type" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="langage" class="font-light" >Language (s)<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.langage" placeholder="" name="langage" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="purpose" class="font-light" >Purpose<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.purpose" placeholder="" name="purpose" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-2xl text-black font-normal">REQUEST FOR CERTIFICATE</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name: {{ form.nom ?? "" }}</th>
                            <th class="text-2xl text-black font-normal">Job title: {{ form.job }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="text-2xl text-black font-normal">Type of Certificate(s)</th>
                            <th class="text-2xl text-black font-normal">{{ form.type }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Language (s)</th>
                            <th class="text-2xl text-black font-normal">{{ form.langage }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Purpose</th>
                            <th class="text-2xl text-black font-normal">{{ form.purpose }}</th>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-14 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Employee’s signature:
                    </p>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-80">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <th class="text-black font-normal text-sm"><span class="font-bold">Type of certificate</span>: Employment certificate, Leave Certificate and Salary Certificate<br>
                                    PS: For <span class="font-bold">leave certificate</span>, a request for leave form must be first completed.</th>
                            </tr>
                            <tr>
                                <th class="text-black font-normal text-sm"><span class="font-bold">Language</span>: English, French or both.</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "RequestForCert",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                job: null,
                type: null,
                langage: null,
                purpose: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.job = null;
            this.form.type = null;
            this.form.langage = null;
            this.form.purpose = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":24,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>